// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__pELXh Dashboard_container__OjzSP","scoreCards":"Dashboard_scoreCards__Wysjo Dashboard_scoreCards__5nZBn"};